import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16c193c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dropdown small"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "caret" }, null, -1))
const _hoisted_4 = { class: "dropdown-menu" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import { computed, ref, toRefs } from 'vue'
import { useGettext } from 'vue3-gettext'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { getErrorMessage, getErrorTitle } from '@/helpers/errors'
import { useWorksStore } from '@/store/works'
import IconUI from '@/components/CommonUI/IconUI.vue'
import WriterUncontrolledDialog from '@/components/MyWorks/WriterUncontrolledDialog.vue'
import { WorkStatuses, timeToAcceptShare } from '@/constants'

interface Props {
  writerId: number,
  workId: number,
  sentEmails: number,
  isControlled: boolean,
  writerCreatedDate: string | undefined,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'WriterActions',
  props: {
    writerId: {},
    workId: {},
    sentEmails: {},
    isControlled: { type: Boolean, default: true },
    writerCreatedDate: {}
  },
  emits: ["handleError", "emailSent", "writerShareAccepted"],
  setup(__props: any, { emit }) {

const props = __props;


const { writerId, workId, sentEmails } = toRefs(props)
const { $gettext } = useGettext()
const workStore = useWorksStore()
const isLoading = ref(false)
dayjs.extend(utc)

const writerUncontrolledDialog = ref<InstanceType<typeof WriterUncontrolledDialog> | null>(null)



const isPendingWork = computed(() => {
  const work = workStore.getWorkById(workId.value)

  return work?.status === WorkStatuses.pending.id
})

function isOlderThan7Days(date: string | undefined) {
  return Math.abs(dayjs.utc(date).diff()) > timeToAcceptShare
}

async function sendInviteEmail() {
  isLoading.value = true

  try {
    await workStore.sendInviteEmail(workId.value, writerId.value)

    emit('emailSent')
  } catch (error) {
    emit('handleError', getErrorTitle(error), getErrorMessage(error))
  }

  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isControlled)
      ? _withDirectives((_openBlock(), _createBlock(IconUI, {
          key: 0,
          name: "danger",
          fill: "warning",
          "data-testid": "UncontrolledWriterIcon"
        }, null, 512)), [
          [_directive_tippy, { content: _unref($gettext)('This writer is uncontrolled. Ditto will not claim royalties for this person.') }]
        ])
      : (isOlderThan7Days(_ctx.writerCreatedDate) && isPendingWork.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(sentEmails) === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("button", {
                    class: "dropdown-toggle button tertiary button-small",
                    "data-toggle": "dropdown",
                    type: "button",
                    disabled: isLoading.value
                  }, [
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(_unref($gettext)('Resend/Accept')) + " ", 1),
                      _hoisted_3
                    ])
                  ], 8, _hoisted_2),
                  _createElementVNode("ul", _hoisted_4, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (sendInviteEmail()), ["prevent"]))
                      }, [
                        _createVNode(IconUI, { name: "email" }),
                        _createTextVNode(" " + _toDisplayString(_unref($gettext)('Resend email')), 1)
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (writerUncontrolledDialog.value?.show(Number(_unref(workId)), Number(_unref(writerId)))), ["prevent"]))
                      }, [
                        _createVNode(IconUI, { name: "check" }),
                        _createTextVNode(" " + _toDisplayString(_unref($gettext)('Accept share')), 1)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button tertiary button-small",
                  type: "button",
                  disabled: isLoading.value,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (writerUncontrolledDialog.value?.show(Number(_unref(workId)), Number(_unref(writerId)))))
                }, _toDisplayString(_unref($gettext)('Accept share')), 9, _hoisted_5))
          ], 64))
        : (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "button tertiary button-small",
            type: "button",
            disabled: _unref(sentEmails) > 0 || isLoading.value,
            onClick: sendInviteEmail
          }, _toDisplayString(_unref(sentEmails) ? _unref($gettext)('Email sent') : _unref($gettext)('Resend email')), 9, _hoisted_6)),
    _createVNode(WriterUncontrolledDialog, {
      ref_key: "writerUncontrolledDialog",
      ref: writerUncontrolledDialog,
      onWriterShareAccepted: _cache[3] || (_cache[3] = ($event: any) => (emit('writerShareAccepted')))
    }, null, 512)
  ], 64))
}
}

})